import { Accordion, AccordionDetails, AccordionSummary } from "@material-ui/core";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { ReactNode } from "react";

import "./index.scss";

interface SubMenuAccordion {
  father: ReactNode;
  children?: ReactNode;
  text?: string;
  icon?: any;
  status: boolean;
  className?: string;
  expanded?: boolean;
  childrenClassName?: string;
  onClickFather?: any;
}

export default function AccordionComponent({
  father,
  children,
  text,
  icon,
  status,
  className,
  expanded,
  childrenClassName,
  onClickFather,
}: SubMenuAccordion) {
  return (
    <div className={`subMenuAccordionContainerHistory ${className}`}>
      {!status ? (
        <Accordion expanded={expanded}>
          <AccordionSummary onClick={onClickFather} expandIcon={icon && <ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
            {father}
          </AccordionSummary>
          <AccordionDetails>
            <div className={`w-full ${childrenClassName} `}>{children}</div>
          </AccordionDetails>
        </Accordion>
      ) : (
        <div className={`menuHiddenAccordion`}>
          {father}
          <div className={`menuHidden w-full`}>
            {" "}
            <div className={`menuHiddenTitle`}>{text}</div>
            {children || ""}
          </div>
        </div>
      )}
    </div>
  );
}
